// angular imports
import { Pipe, PipeTransform } from '@angular/core';

// service imports
import { HelperService } from '../_services/shared-services/helper.service';

@Pipe({
    name: 'ccFileIcon'
})
export class CCFileIconPipe implements PipeTransform {
    constructor(private readonly helperService: HelperService) {}
    transform(fileName: string): string {
        return this.helperService.getFileIconByExtension(fileName);
    }
}
